import BidDashboard from "@krea/customer-features/shared-components/bid-dashboards/bid-dashboard";

import {
  useGetCurrentLoanApplication,
  useGetSelectedLenderResponse,
} from "store/current-loan-application/hooks/queries";
import { useSelectLenderResponse } from "store/lender-responses/hooks/mutations/useSelectLenderResponse";
import { useGetLenderResponses } from "store/lender-responses/hooks/queries";

export const Dashboard = () => {
  const { data } = useGetCurrentLoanApplication();

  const state = data?.state;
  const product = data?.product;
  const biddingEndsAt = data?.biddingEndsAt;
  const customerPreferredRate = data?.customerPreferredRate;
  const { data: lenderResponsesData, isLoading } = useGetLenderResponses();
  const { data: selectedLenderResponse } = useGetSelectedLenderResponse();
  const selectLenderResponseMutation = useSelectLenderResponse();

  return (
    <BidDashboard
      lenderResponsesData={lenderResponsesData}
      selectedLenderResponse={selectedLenderResponse}
      state={state!}
      product={product!}
      biddingEndsAt={biddingEndsAt!}
      customerPreferredRate={customerPreferredRate!}
      isLoading={isLoading}
      selectLenderResponseMutation={selectLenderResponseMutation}
    />
  );
};
